<template>
  <div>
    <div
      style="position: fixed; top: 20px; z-index: 5; backdrop-filter: blur(2px)"
      v-if="LoaderStatus"
    >
      <Spinner />
    </div>
    <div class="new-reports d-flex flex-column pb-2">
      <div
        class="
          new-reports-header
          py-2
          px-3
          d-flex
          align-items-center
          justify-content-between
        "
      >
        <div class="title-nav d-flex align-items-center">
          <img
            src="../../assets/ReportsNew/goBack.svg"
            alt=""
            class="pointer"
            @click="goBack"
          />
          <span class="title">Recruiter Reports</span>
        </div>
        <div class="daily-option">
          <button
            type="button"
            class="px-4 py-1 d-flex align-items-center"
            @click.stop="openDurationList"
          >
            <span>{{ DisplayTimeline }}</span>
            <img src="../../assets/ReportsNew/chevron_down.svg" alt="Open" />
          </button>
          <div
            class="report-duration-dropdown"
            style="margin-top: 2px"
            v-if="durationListOpen"
            ref="dropdown1"
          >
            <div
              class="duration-item pointer"
              :style="
                this.timeline == 'today' || this.storeTimeline == 'today'
                  ? 'background: #c8d9e5'
                  : ''
              "
              @click="setTimeline('today')"
            >
              Today
            </div>
            <div
              class="duration-item pointer"
              :style="
                this.timeline == 'thisWeek' || this.storeTimeline == 'thisWeek'
                  ? 'background: #c8d9e5'
                  : ''
              "
              @click="setTimeline('thisWeek')"
            >
              This Week
            </div>
            <div
              class="duration-item pointer"
              :style="
                this.timeline == 'thisMonth' ||
                this.storeTimeline == 'thisMonth'
                  ? 'background: #c8d9e5'
                  : ''
              "
              @click="setTimeline('thisMonth')"
            >
              This Month
            </div>
            <div
              class="duration-item pointer"
              :style="
                this.timeline == 'thisYear' || this.storeTimeline == 'thisYear'
                  ? 'background: #c8d9e5'
                  : ''
              "
              @click="setTimeline('thisYear')"
            >
              This Year
            </div>
            <div
              class="duration-item custom p-0"
              :style="
                this.timeline == 'custom' && this.appliedFilter
                  ? 'background: #c8d9e5'
                  : ''
              "
              @click="setTimeline('custom')"
            >
              <div
                class="
                  d-flex
                  align-items-center
                  justify-content-between
                  pointer
                "
                @click.stop="customDurationOpen = !customDurationOpen"
                style="padding: 8px 10px"
              >
                <span>Custom</span>
                <img
                  src="../../assets/ReportsNew/chevron_right.svg"
                  alt="Open Custom"
                  style="height: 8px"
                />
              </div>

              <div
                class="custom-duration-menu p-3"
                v-if="customDurationOpen"
                ref="dropdown2"
              >
                <span class="custom-title">Custom View</span>
                <div class="topDiv mt-3">
                  <DateField
                    :type="'date'"
                    :label="'From Date'"
                    :mandatory="false"
                    :placeholder="'Choose From Date'"
                    :id="'fromDate'"
                    :format="'DD-MM-YYYY'"
                    :vmodel="fromDate"
                    @select-value="fromDate = $event"
                  />
                </div>
                <div class="topDiv mt-3">
                  <DateField
                    :type="'date'"
                    :label="'To Date'"
                    :mandatory="false"
                    :placeholder="'Choose To Date'"
                    :id="'toDate'"
                    :format="'DD-MM-YYYY'"
                    :vmodel="toDate"
                    @select-value="toDate = $event"
                    :startDate="fromDate"
                  />
                </div>
                <div class="topDiv mt-3">
                  <DateField
                    :type="'time'"
                    :label="'Start Time'"
                    :mandatory="false"
                    :placeholder="'Choose Start Time'"
                    :id="'startPanTime'"
                    :format="'HH:mm:ss'"
                    :vmodel="startTime"
                    @select-value="startTime = $event"
                    :disabled="fromDate == '' && toDate == ''"
                    icon="time"
                  />
                </div>
                <div class="topDiv mt-3">
                  <DateField
                    :type="'time'"
                    :label="'End time'"
                    :mandatory="false"
                    :placeholder="'Choose End Time'"
                    :id="'endPanTime'"
                    :format="'HH:mm:ss'"
                    :vmodel="endTime"
                    @select-value="endTime = $event"
                    :disabled="fromDate == '' && toDate == ''"
                    icon="time"
                  />
                </div>

                <div class="d-flex justify-content-between mt-4 bluebtn">
                  <b-button class="acs-cancelBtn-filter" @click="cancelCustom"
                    >Cancel</b-button
                  >
                  <div class="d-flex">
                    <b-button
                      class="acs-cancelBtn-filter mr-3"
                      :disabled="fromDate == '' && toDate == ''"
                      @click="resetCustom"
                      >Reset</b-button
                    >
                    <b-button
                      class="acs-cancelBtn-filter"
                      :disabled="fromDate == '' && toDate == ''"
                      @click="applyCustom"
                      >Apply</b-button
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="overview-tab px-3 py-3">
        <span class="tab-title">Overview</span>
        <div class="overview-items-flex d-flex align-items-center w-100">
          <div class="overview-item">
            <span class="item-title">Total Recruiters</span>
            <span class="item-value">{{ recTotal }}</span>
          </div>
          <div class="overview-item">
            <span class="item-title">Total Candidates Sourced</span>
            <span class="item-value">{{ recTotalCandSourced }}</span>
          </div>
          <div class="overview-item">
            <span class="item-title">Total Assigned Jobs</span>
            <span class="item-value">{{ recJobsAssigned }}</span>
          </div>
          <div class="overview-item">
            <span class="item-title">Total Interviews Scheduled</span>
            <span class="item-value">{{ recSchedCount }}</span>
          </div>
          <div class="overview-item">
            <span class="item-title">Total Selected Candidates</span>
            <span class="item-value">{{ recTotalSelect }}</span>
          </div>
          <!-- <div class="overview-item">
            <span class="item-title">Average Selection rate</span>
            <span class="item-value">50</span>
          </div> -->
        </div>
      </div>

      <!-- Recruiters Table -->
      <div class="table-panel px-1">
        <div
          class="
            table-title-bar
            d-flex
            align-items-center
            justify-content-between
            px-3
            py-2
          "
        >
          <span class="table-title">Recruiters</span>
          <div class="search-export-options d-flex align-items-center">
            <div class="search-bar d-flex align-items-center px-3">
              <img src="../../assets/ReportsNew/searchIcon.svg" alt="" />
              <b-form-input
                type="search"
                class="mb-1"
                placeholder="Search Recruiters"
                v-model.trim="recSearchQuery"
                debounce="500"
                @update="getSearchedRec"
              />
            </div>
            <button
              type="button"
              class="export-excel px-4 py-1"
              @click="openExcel()"
            >
              Export Excel
            </button>
          </div>
        </div>
        <div class="custReport-main-table">
          <div class="mainCust-table-head">
            <div class="d-flex align-items-center" style="width: 30%">
              <div>Recruiter Name</div>
              <div class="sort-header p-1 ml-1 d-flex flex-column">
                <img
                  v-if="recSort != 'name'"
                  @click="sortData('name', 1)"
                  class="pointer"
                  src="../../assets/img/accessconnew/nosort.svg"
                  alt
                />
                <img
                  v-else-if="recSort && recOrder == 1"
                  @click="sortData('name', -1)"
                  class="pointer"
                  src="../../assets/img/accessconnew/ascSort.svg"
                  alt
                />
                <img
                  v-else-if="recSort && recOrder == -1"
                  @click="sortData('name', 1)"
                  class="pointer"
                  src="../../assets/img/accessconnew/descSort.svg"
                  alt
                />
              </div>
            </div>
            <div class="d-flex align-items-center" style="width: 20%">
              <div>Candidates Sourced</div>
              <div class="sort-header p-1 ml-1 d-flex flex-column">
                <img
                  v-if="recSort != 'candidateSourcedCount'"
                  @click="sortData('candidateSourcedCount', 1)"
                  class="pointer"
                  src="../../assets/img/accessconnew/nosort.svg"
                  alt
                />
                <img
                  v-else-if="recSort && recOrder == 1"
                  @click="sortData('candidateSourcedCount', -1)"
                  class="pointer"
                  src="../../assets/img/accessconnew/ascSort.svg"
                  alt
                />
                <img
                  v-else-if="recSort && recOrder == -1"
                  @click="sortData('candidateSourcedCount', 1)"
                  class="pointer"
                  src="../../assets/img/accessconnew/descSort.svg"
                  alt
                />
              </div>
            </div>
            <div class="d-flex align-items-center" style="width: 20%">
              <div>Assigned Jobs</div>
              <div class="sort-header p-1 ml-1 d-flex flex-column">
                <img
                  v-if="recSort != 'jobsAssignedCount'"
                  @click="sortData('jobsAssignedCount', 1)"
                  class="pointer"
                  src="../../assets/img/accessconnew/nosort.svg"
                  alt
                />
                <img
                  v-else-if="recSort && recOrder == 1"
                  @click="sortData('jobsAssignedCount', -1)"
                  class="pointer"
                  src="../../assets/img/accessconnew/ascSort.svg"
                  alt
                />
                <img
                  v-else-if="recSort && recOrder == -1"
                  @click="sortData('jobsAssignedCount', 1)"
                  class="pointer"
                  src="../../assets/img/accessconnew/descSort.svg"
                  alt
                />
              </div>
            </div>
            <div class="d-flex align-items-center" style="width: 15%">
              <div>Interview Scheduled</div>
              <div class="sort-header p-1 ml-1 d-flex flex-column">
                <img
                  v-if="recSort != 'interviewScheduledCount'"
                  @click="sortData('interviewScheduledCount', 1)"
                  class="pointer"
                  src="../../assets/img/accessconnew/nosort.svg"
                  alt
                />
                <img
                  v-else-if="recSort && recOrder == 1"
                  @click="sortData('interviewScheduledCount', -1)"
                  class="pointer"
                  src="../../assets/img/accessconnew/ascSort.svg"
                  alt
                />
                <img
                  v-else-if="recSort && recOrder == -1"
                  @click="sortData('interviewScheduledCount', 1)"
                  class="pointer"
                  src="../../assets/img/accessconnew/descSort.svg"
                  alt
                />
              </div>
            </div>
            <div class="d-flex align-items-center" style="width: 15%">
              <div>Selected Candidates</div>
              <div class="sort-header p-1 ml-1 d-flex flex-column">
                <img
                  v-if="recSort != 'selectedCount'"
                  @click="sortData('selectedCount', 1)"
                  class="pointer"
                  src="../../assets/img/accessconnew/nosort.svg"
                  alt
                />
                <img
                  v-else-if="recSort && recOrder == 1"
                  @click="sortData('selectedCount', -1)"
                  class="pointer"
                  src="../../assets/img/accessconnew/ascSort.svg"
                  alt
                />
                <img
                  v-else-if="recSort && recOrder == -1"
                  @click="sortData('selectedCount', 1)"
                  class="pointer"
                  src="../../assets/img/accessconnew/descSort.svg"
                  alt
                />
              </div>
            </div>
          </div>
          <div class="mainCust-table-body p-1" @scroll="recScroll">
            <template
              v-if="
                (recData.length == 0 &&
                  recSearchQuery == '' &&
                  !recScrollSpinner &&
                  !checkTimeLineData) ||
                recMainSpinner
              "
            >
              <div
                style="margin: auto"
                class="d-flex justify-content-center align-items-center h-100"
              >
                <b-spinner label="Loading..."></b-spinner>
              </div>
            </template>
            <template
              v-else-if="
                recData.length == 0 && checkTimeLineData && recSearchQuery == ''
              "
            >
              <div
                class="
                  d-flex
                  justify-content-center
                  align-items-center
                  h-100
                  flex-column
                "
              >
                <div>
                  <img
                    src="../../assets/ReportsNew/no-reports-svg.svg"
                    alt=""
                  />
                </div>
                <div
                  class="no-matching-results-font mt-1 wordbreak text-center"
                >
                  No reports to show!
                </div>
              </div>
            </template>
            <template v-else-if="recData.length == 0 && recSearchQuery !== ''">
              <div
                class="
                  d-flex
                  justify-content-center
                  align-items-center
                  h-100
                  flex-column
                "
              >
                <div>
                  <img
                    src="../../assets/ReportsNew/panel-wrong-search.svg"
                    alt=""
                  />
                </div>
                <div
                  class="no-matching-results-font mt-1 wordbreak text-center"
                >
                  No matching results found for "{{ recSearchQuery }}"
                </div>
              </div>
            </template>
            <template v-else-if="recData.length !== 0 && !recMainSpinner">
              <div
                class="custReport-table-row pointer"
                v-for="(rec, recIndex) in recData"
                :key="recIndex"
                @click="SelectRow(rec.name, rec.recruiterUserID)"
                :class="
                  selectedRow == rec.recruiterUserID ? 'cust-row-selected' : ''
                "
              >
                <div class="sideGridBlueColor" style="height: 65px"></div>
                <div style="width: 30%">
                  <div class="text-truncate">
                    <span
                      v-b-tooltip.hover.top="rec.name"
                      class="d-inline-block text-truncate"
                      style="min-width: auto; max-width: 80%"
                    >
                      {{ rec.name }}
                    </span>
                  </div>
                  <div class="selec-rate-font">
                    Selection rate: {{ rec.selectionRate }}
                  </div>
                </div>
                <div style="width: 20%">{{ rec.candidateSourcedCount }}</div>
                <div style="width: 20%">{{ rec.jobsAssignedCount }}</div>
                <div style="width: 15%">{{ rec.interviewScheduledCount }}</div>
                <div style="width: 15%">{{ rec.selectedCount }}</div>
              </div>
              <div
                style="margin: auto"
                v-if="recScrollSpinner"
                class="d-flex justify-content-center mt-2"
              >
                <b-spinner label="Loading..."></b-spinner>
              </div>
            </template>
          </div>
        </div>
      </div>

      <!-- Overall Reports Section -->
      <div class="overall-reports relativeclass">
        <div
          class="
            overall-reports-header
            d-flex
            align-items-end
            justify-content-between
            w-100
          "
        >
          <div class="title-section d-flex flex-column" style="width: 75%">
            <span class="title">Overall Report</span>
            <span class="sub-title"
              >(Click on Recruiter Name to see their report)</span
            >
          </div>
          <div
            class="d-flex align-items-center"
            style="position: absolute; right: 0"
          >
            <div
              class="filter-section d-flex align-items-center pr-4"
              ref="filter"
              v-closable="{
                exclude: ['filter', 'filterdropdown'],
                handler: 'cancelFilterSection',
              }"
            >
              <div class="w-100 d-flex align-items-center justify-content-end">
                <div>Show Results for:</div>
                <div class="custom-dropdown pl-3">
                  <div
                    class="selected-filter d-flex align-items-center w-100"
                    @click="toggleReportsFilter"
                  >
                    <div class="text-truncate" style="width: 90px">
                      <div
                        class="d-inline-block text-truncate mt-1"
                        style="min-width: auto; max-width: 100%"
                      >
                        <template v-if="selectedRow == 'all'">
                          All Recruiters
                        </template>
                        <template v-else>
                          {{ selectedRowName }}
                        </template>
                      </div>
                    </div>
                    <div>
                      <img
                        src="../../assets/ReportsNew/chev_down_blue.svg"
                        alt=""
                      />
                    </div>
                  </div>

                  <div
                    class="filter-list-dropdown"
                    v-if="overallReportsFilter"
                    style="width: 248px"
                  >
                    <div class="filter-search">
                      <img
                        src="../../assets/ReportsNew/searchIcon.svg"
                        alt=""
                      />
                      <b-form-input
                        type="search"
                        name="overallReportsSearch"
                        id="overallReportsSearch"
                        placeholder="Search"
                        v-model.trim="overAllSearchQuery"
                        debounce="500"
                        @update="searchoverALlPanel"
                      />
                    </div>
                    <div class="filter-list w-100" @scroll="scrollOverAllPanel">
                      <template
                        v-if="
                          (overAllRecData.length == 0 &&
                            overAllSearchQuery == '' &&
                            !checkoverAllScrollLoader &&
                            !checkTimeLineData) ||
                          showOverAllLoader
                        "
                      >
                        <div
                          style="margin: auto"
                          class="
                            d-flex
                            justify-content-center
                            align-items-center
                            mt-2
                            h-100
                          "
                        >
                          <b-spinner label="Loading..."></b-spinner>
                        </div>
                      </template>
                      <template
                        v-if="
                          overAllRecData.length == 0 &&
                          checkTimeLineData &&
                          !showOverAllLoader
                        "
                      >
                        <div
                          class="
                            no-matching-results-font
                            mt-1
                            wordbreak
                            text-center
                          "
                        >
                          No Records found
                        </div>
                      </template>
                      <template
                        v-else-if="
                          overAllRecData.length !== 0 && !showOverAllLoader
                        "
                      >
                        <div
                          v-if="overAllSearchQuery == ''"
                          class="pointer"
                          @click="selectAllpanelRow"
                          :class="
                            selectedRow == 'all' ? 'cust-row-selected' : ''
                          "
                        >
                          All Recruiters
                        </div>
                        <div
                          class="w-100 wordbreak pointer"
                          v-for="(over, overIndex) in overAllRecData"
                          :key="overIndex"
                          @click="
                            SelectOverallRow(over.name, over.recruiterUserID)
                          "
                          :class="
                            selectedRow == over.recruiterUserID
                              ? 'cust-row-selected'
                              : ''
                          "
                        >
                          {{ over.name }}
                        </div>
                        <div
                          v-if="checkoverAllScrollLoader"
                          style="margin: auto"
                          class="
                            d-flex
                            justify-content-center
                            align-items-center
                            mt-2
                          "
                        >
                          <b-spinner label="Loading..."></b-spinner>
                        </div>
                      </template>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex justify-content-between mt-12px">
        <div class="half-graph-container w-49-7 position-relative">
          <div
            class="
              d-flex
              justify-content-between
              align-items-center
              border-bottom
              px-2
              pb-2
            "
          >
            <div class="dashboardAdmin-cards-head ml-2">Candidates Sourced</div>
            <div class="d-flex align-items-center">
              <span class="rep-grey-txt mr-3"
                >Total Count : {{ totalSourceCount }}</span
              >
            </div>
          </div>

          <div
            style="margin: auto"
            v-if="sourceLoader"
            class="d-flex justify-content-center align-items-center h-100"
          >
            <b-spinner label="Loading..."></b-spinner>
          </div>

          <div
            v-else-if="totalSourceCount < 1 && !sourceLoader"
            class="d-flex align-items-center justify-content-center w-100 h-100"
          >
            <img src="../../assets/ReportsNew/thirdPartyNodata.svg" alt="" />
          </div>
          <div
            v-else
            class="w-100 d-flex justify-content-center"
            id="sourceGraph"
          ></div>
          <div
            v-if="totalSourceCount > 0 && !sourceLoader"
            class="legend-container d-flex flex-column"
          >
            <div
              class="d-flex align-items-center"
              v-for="(gData, ind) in sourceGraphData"
              :key="ind + 'selec'"
            >
              <span
                class="legend-color-disc"
                :style="{ backgroundColor: gData.clrCode }"
              ></span>
              <span class="legend-item-name">{{ gData.roleName }}</span>
            </div>
          </div>
        </div>
        <div class="half-graph-container w-49-7">
          <div
            class="
              d-flex
              justify-content-between
              align-items-center
              border-bottom
              px-2
              pb-2
            "
          >
            <div class="dashboardAdmin-cards-head ml-2">
              Candidate Experience
            </div>
            <div class="d-flex align-items-center">
              <span class="rep-grey-txt mr-3"
                >Total Count : {{ overallCountAssessment }}</span
              >
            </div>
          </div>

          <div
            style="margin: auto"
            v-if="expLoader"
            class="d-flex justify-content-center align-items-center h-100"
          >
            <b-spinner label="Loading..."></b-spinner>
          </div>

          <div
            v-if="noExperienceData"
            class="d-flex align-items-center justify-content-center w-100 h-100"
          >
            <img src="../../assets/ReportsNew/recDashboardNodata.svg" alt="" />
          </div>

          <div
            v-else
            class="report-content p-2 assesGraph"
            style="width: 100%; height: 100%"
            id="assesmentTakenGraph"
          ></div>
        </div>
      </div>
      <!-- Sourced Skills Section -->
      <div class="sourced-skills px-1">
        <div class="source-title-bar px-3 py-2">
          <span class="source-title">Sourced Skills</span>
        </div>
        <div class="p-3">
          <template
            v-if="(!hasSkills && !checkTimeLineData) || sourceMainScroll"
          >
            <div
              style="margin: auto"
              class="
                d-flex
                justify-content-center
                align-items-center
                mt-2
                h-100
              "
            >
              <b-spinner label="Loading..."></b-spinner>
            </div>
          </template>
          <template v-if="!hasSkills && checkTimeLineData && !sourceMainScroll">
            <div class="no-matching-results-font mt-1 wordbreak text-center">
              No Records found
            </div>
          </template>
          <template v-else-if="hasSkills && !sourceMainScroll">
            <div class="skills-chips-flex">
              <span
                class="chip px-2 py-1 rounded-lg"
                v-for="(skill, index) in displayedSkills"
                :key="index"
              >
                {{ skill }}
              </span>
              <!-- Show "more" only if skills are more than 32 and not in expanded mode -->
              <span
                class="chip show-all px-2 py-1 rounded-lg"
                v-if="!skillListOpen && hasMoreThan32Skills"
                @click="showAllSourcedSkills"
              >
                +{{ remainingSkillCount }} more
              </span>
              <!-- Show "less" only if skills are more than 32 and in expanded mode -->
              <span
                class="chip show-all px-2 py-1 rounded-lg"
                v-else-if="skillListOpen && hasMoreThan32Skills"
                @click="showAllSourcedSkills"
              >
                Show less
              </span>
            </div>
          </template>
        </div>
      </div>

      <!-- Selected Candidates Table -->
      <div class="table-panel px-1">
        <div
          class="
            table-title-bar
            d-flex
            align-items-center
            justify-content-between
            px-3
            py-2
          "
        >
          <span class="table-title">Selected Candidates</span>
          <div class="search-export-options d-flex align-items-center">
            <div class="search-bar d-flex align-items-center px-3">
              <img src="../../assets/ReportsNew/searchIcon.svg" alt="Search" />
              <b-form-input
                type="search"
                class="mb-1"
                placeholder="Search Candidates"
                v-model.trim="recSelectedSearchQuery"
                debounce="500"
                @update="getSearchSelectedData"
              />
            </div>
          </div>
        </div>
        <div class="custReport-main-table">
          <div class="mainCust-table-head">
            <div class="d-flex align-items-center" style="width: 16%">
              <span>Candidate Name</span>
              <div class="sort-header p-1 ml-1 d-flex flex-column">
                <img
                  v-if="recSelectedSort != 'candidateName'"
                  @click="sortSelectedData('candidateName', 1)"
                  class="pointer"
                  src="../../assets/img/accessconnew/nosort.svg"
                  alt
                />
                <img
                  v-else-if="recSelectedSort && recSelectedOrder == 1"
                  @click="sortSelectedData('candidateName', -1)"
                  class="pointer"
                  src="../../assets/img/accessconnew/ascSort.svg"
                  alt
                />
                <img
                  v-else-if="recSelectedSort && recSelectedOrder == -1"
                  @click="sortSelectedData('candidateName', 1)"
                  class="pointer"
                  src="../../assets/img/accessconnew/descSort.svg"
                  alt
                />
              </div>
            </div>
            <div class="d-flex align-items-center" style="width: 16%">
              <span>Job Name</span>
              <div class="sort-header p-1 ml-1 d-flex flex-column">
                <img
                  v-if="recSelectedSort != 'jobName'"
                  @click="sortSelectedData('jobName', 1)"
                  class="pointer"
                  src="../../assets/img/accessconnew/nosort.svg"
                  alt
                />
                <img
                  v-else-if="recSelectedSort && recSelectedOrder == 1"
                  @click="sortSelectedData('jobName', -1)"
                  class="pointer"
                  src="../../assets/img/accessconnew/ascSort.svg"
                  alt
                />
                <img
                  v-else-if="recSelectedSort && recSelectedOrder == -1"
                  @click="sortSelectedData('jobName', 1)"
                  class="pointer"
                  src="../../assets/img/accessconnew/descSort.svg"
                  alt
                />
              </div>
            </div>
            <div class="d-flex align-items-center" style="width: 18%">
              <span>Skills</span>
            </div>
            <div class="d-flex align-items-center" style="width: 9%">
              <span>Source</span>
              <div class="sort-header p-1 ml-1 d-flex flex-column">
                <img
                  v-if="recSelectedSort != 'source'"
                  @click="sortSelectedData('source', 1)"
                  class="pointer"
                  src="../../assets/img/accessconnew/nosort.svg"
                  alt
                />
                <img
                  v-else-if="recSelectedSort && recSelectedOrder == 1"
                  @click="sortSelectedData('source', -1)"
                  class="pointer"
                  src="../../assets/img/accessconnew/ascSort.svg"
                  alt
                />
                <img
                  v-else-if="recSelectedSort && recSelectedOrder == -1"
                  @click="sortSelectedData('source', 1)"
                  class="pointer"
                  src="../../assets/img/accessconnew/descSort.svg"
                  alt
                />
              </div>
            </div>
            <div class="d-flex align-items-center" style="width: 11%">
              <span>Status</span>
              <div class="sort-header p-1 ml-1 d-flex flex-column">
                <img
                  v-if="recSelectedSort != 'source'"
                  @click="sortSelectedData('source', 1)"
                  class="pointer"
                  src="../../assets/img/accessconnew/nosort.svg"
                  alt
                />
                <img
                  v-else-if="recSelectedSort && recSelectedOrder == 1"
                  @click="sortSelectedData('source', -1)"
                  class="pointer"
                  src="../../assets/img/accessconnew/ascSort.svg"
                  alt
                />
                <img
                  v-else-if="recSelectedSort && recSelectedOrder == -1"
                  @click="sortSelectedData('source', 1)"
                  class="pointer"
                  src="../../assets/img/accessconnew/descSort.svg"
                  alt
                />
              </div>
            </div>
            <div class="d-flex align-items-center" style="width: 14%">
              <span>Onboarding Date</span>
              <div class="sort-header p-1 ml-1 d-flex flex-column">
                <img
                  v-if="recSelectedSort != 'source'"
                  @click="sortSelectedData('source', 1)"
                  class="pointer"
                  src="../../assets/img/accessconnew/nosort.svg"
                  alt
                />
                <img
                  v-else-if="recSelectedSort && recSelectedOrder == 1"
                  @click="sortSelectedData('source', -1)"
                  class="pointer"
                  src="../../assets/img/accessconnew/ascSort.svg"
                  alt
                />
                <img
                  v-else-if="recSelectedSort && recSelectedOrder == -1"
                  @click="sortSelectedData('source', 1)"
                  class="pointer"
                  src="../../assets/img/accessconnew/descSort.svg"
                  alt
                />
              </div>
            </div>

            <div class="d-flex align-items-center" style="width: 12%">
              <span>Experience <i style="font-weight: 400">(in years)</i></span>
              <div class="sort-header p-1 ml-1 d-flex flex-column">
                <img
                  v-if="recSelectedSort != 'experience'"
                  @click="sortSelectedData('experience', 1)"
                  class="pointer"
                  src="../../assets/img/accessconnew/nosort.svg"
                  alt
                />
                <img
                  v-else-if="recSelectedSort && recSelectedOrder == 1"
                  @click="sortSelectedData('experience', -1)"
                  class="pointer"
                  src="../../assets/img/accessconnew/ascSort.svg"
                  alt
                />
                <img
                  v-else-if="recSelectedSort && recSelectedOrder == -1"
                  @click="sortSelectedData('experience', 1)"
                  class="pointer"
                  src="../../assets/img/accessconnew/descSort.svg"
                  alt
                />
              </div>
            </div>
            <div class="d-flex align-items-center" style="width: 4%">
              <span>Action</span>
            </div>
          </div>
          <div class="mainCust-table-body p-1">
            <template
              v-if="
                recSelectedData.length == 0 &&
                checkTimeLineData &&
                recSelectedSearchQuery == ''
              "
            >
              <div
                class="
                  d-flex
                  justify-content-center
                  align-items-center
                  h-100
                  flex-column
                "
              >
                <div>
                  <img
                    src="../../assets/ReportsNew/no-reports-svg.svg"
                    alt=""
                  />
                </div>
                <div
                  class="no-matching-results-font mt-1 wordbreak text-center"
                >
                  No reports to show!
                </div>
              </div>
            </template>
            <template
              v-else-if="
                recSelectedData.length == 0 && recSelectedSearchQuery !== ''
              "
            >
              <div
                class="
                  d-flex
                  justify-content-center
                  align-items-center
                  mt-2
                  h-100
                  flex-column
                "
              >
                <div>
                  <img
                    src="../../assets/ReportsNew/panel-wrong-search.svg"
                    alt=""
                  />
                </div>
                <div
                  class="no-matching-results-font mt-1 wordbreak text-center"
                >
                  No matching results found for "{{ recSelectedSearchQuery }}"
                </div>
              </div>
            </template>
            <template
              v-else-if="recSelectedData.length !== 0 && !recSelectedMainScroll"
            >
              <div
                class="custReport-table-row"
                v-for="(selectedCand, selectedCandIndex) in recSelectedData"
                :key="selectedCandIndex"
              >
                <div class="sideGridBlueColor"></div>
                <div class="text-truncate" style="width: 16%">
                  <div
                    v-b-tooltip.hover.top="selectedCand.candidateName"
                    class="d-inline-block text-truncate"
                    style="min-width: auto; max-width: 80%"
                  >
                    {{ selectedCand.candidateName }}
                  </div>
                </div>
                <div class="text-truncate" style="width: 16%">
                  <div
                    v-b-tooltip.hover.top="selectedCand.jobName"
                    class="d-inline-block text-truncate"
                    style="min-width: auto; max-width: 80%"
                  >
                    {{ selectedCand.jobName }}
                  </div>
                </div>
                <div style="width: 18%">
                  <div
                    v-if="
                      selectedCand.canSkills &&
                      selectedCand.canSkills.length > 0
                    "
                    class="d-inline-block text-truncate"
                    style="min-width: auto; max-width: 80%"
                    v-b-tooltip.hover="{
                      title: formattedSkillsTooltip(selectedCand.canSkills),
                    }"
                  >
                    {{ formattedSkills(selectedCand.canSkills) }}
                  </div>
                  <div v-else>-</div>
                </div>
                <div style="width: 9%" class="pl-1">
                  {{ selectedCand.source }}
                </div>
                <div style="width: 11%" class="pl-1">
                  {{
                    selectedCand.onboarding
                      ? "On-Boarded"
                      : selectedCand.offerletterIssued
                      ? "Issued Offer Letter"
                      : "-"
                  }}
                </div>
                <div style="width: 14%" class="pl-1">
                  {{
                    selectedCand.onboardingDate
                      ? convertDate(selectedCand.onboardingDate)
                      : "-"
                  }}
                </div>
                <div style="width: 12%" class="pl-2">
                  <template v-if="selectedCand.experience != ''">
                    {{ selectedCand.experience }}
                  </template>
                  <template v-else> - </template>
                </div>
                <div style="width: 4%" class="pl-2">
                  <template>
                    <img
                      v-if="
                        selectedCand.candidateID !=
                        selectedCandidate.candidateID
                      "
                      v-b-tooltip.hover.top="'View Candidate'"
                      src="../../assets/talentpool/blueEye.svg"
                      alt=""
                      @click="viewCandidate(selectedCand)"
                      class="px-1 mr-2 pointer"
                    />

                    <img
                      v-else
                      src="../../assets/talentpool/notviewicon.svg"
                      alt=""
                      class="px-1 mr-2"
                    />
                  </template>
                </div>
              </div>
            </template>
          </div>
          <div
            v-if="recSelectedData.length > 0"
            class="
              acs-paginaTion-new
              d-flex
              justify-content-between
              align-items-center
              transaction-paginaTion-new
            "
          >
            <div class="d-flex">
              <span class="acs-gotopage-text p-1 mr-2">Go to page</span>
              <b-form-input
                autocomplete="off"
                type="text"
                @keypress="NumbersOnly"
                @paste="handlePaste"
                v-model.number="goToPage"
                @keyup.enter="handleGoToPage"
                class="acs-pagination-num"
              ></b-form-input>
              <div class="acs-pagination-addbtn" @click="handleGoToPage">
                <span>
                  <img src="../../assets/panelist/page_arrow.svg" alt />
                </span>
              </div>
            </div>

            <div class="pagination">
              <b-pagination
                v-model="currentPage"
                @change="handlePageChange"
                :total-rows="total"
                :per-page="count"
                align="center"
                first-number
                last-number
              >
                <template #prev-text>
                  <span>
                    <img src="../../assets/img/accessconnew/pageleft.svg" alt />
                  </span>
                </template>
                <template #next-text>
                  <span>
                    <img
                      src="../../assets/img/accessconnew/pageright.svg"
                      alt
                    />
                  </span>
                </template>
              </b-pagination>
            </div>
            <div class="d-flex align-items-center">
              <PageInput :pagecount="count" @update-value="updatePage" />

              <div
                class="acs-gotopage-text mr-2 ml-4 d-flex justify-content-end"
              >
                Showing :
                <div
                  class="text-truncate ml-2 results-individual-width"
                  v-if="pageStart > total"
                >
                  0
                </div>
                <div v-else class="text-truncate ml-2 results-individual-width">
                  {{ pageStart }}
                </div>
                <div class="text-truncate results-individual-width">-</div>
                <div class="text-truncate results-individual-width">
                  {{ pageEnd }}
                </div>
                <div class="text-truncate ml-1 results-individual-width">
                  of
                </div>
                <div
                  class="text-truncate ml-1 results-individual-width"
                  style="max-width: 20%"
                >
                  {{ total }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- modal view particular candidates -->
    <PreviewCandidateSidebar
      v-if="viewCandidateModal"
      :showModal="viewCandidateModal"
      :selectedCandidate="selectedCandidate"
      :candidateID="selectedCandidate.candidateID"
      :customFieldsArray="customFieldsArray"
      :showNote="false"
      @close-view-icon="closeViewIcon"
    />
  </div>
</template>
<script>
import {
  getRecruiterReports,
  getRecruiterSources,
  getSelectedRecruiter,
  getCustomerFields,
  RecSourseGraph,
  RecCandExperience,
  getRecruiterReportsEcel,
  // RecCandExperience
} from "../../utils/apiFunctions";
import Spinner from "../../components/fixedcomponents/Spinner.vue";
import DateField from "../../components/InputComponents/DateField";
import PreviewCandidateSidebar from "../../controllers/JD/modals/PreviewCandidateSidebar.vue";
import { rolePieChart, horizontalScroll } from "vue-d3-charts-hire3x";
import { NumbersOnly } from "@/controllers/Candidate/helpers";
import PageInput from "@/components/InputComponents/PaginationInput.vue";
import { mapGetters } from "vuex";

export default {
  name: "RecruiterReports",
  components: {
    Spinner,
    DateField,
    PreviewCandidateSidebar,
    PageInput,
  },
  data() {
    return {
      LoaderStatus: false,
      timeline: "thisMonth",
      storeTimeline: "thisMonth",
      fromDate: "",
      toDate: "",
      startTime: "",
      endTime: "",
      appliedFilter: false,
      storeFromDate: "",
      storeToDate: "",
      storeStartTime: "",
      storeEndTime: "",

      selectedRowName: "",
      selectedRecID: "",
      selectedRow: "all",

      listSize: 40,
      skillListOpen: false,
      durationListOpen: false,
      customDurationOpen: false,
      overallReportsFilter: false,

      // recruiter variables
      recPage: 0,
      recCount: 10,
      recSearchQuery: "",
      recSort: "createdAt",
      recOrder: -1,
      recData: [],
      recTotal: null,
      recPageEnd: null,
      recTotalSelect: null,
      recSchedCount: null,
      recJobsAssigned: null,
      recTotalCandSourced: null,
      recMainSpinner: false,
      recScrollSpinner: false,

      // overall report
      overAllSearchQuery: "",
      showOverAllLoader: false,
      overAllRecData: [],
      heatmapSpinner: false,
      overAllSort: "createdAt",
      overAllCount: 10,
      overAllPage: 0,
      overAllOrder: -1,
      overAllTotal: null,
      overAllPageEnd: null,
      checkoverAllScrollLoader: false,
      sourceGraphData: [],
      noSourceData: true,
      totalSourceCount: null,
      overallCountAssessment: null,
      noExperienceData: true,

      // sourd data
      getSourcedData: [],
      sourceMainScroll: false,

      // selectedData
      recSelectedData: [],
      recSelectedSearchQuery: "",
      recSelectedPage: 0,
      recSelectedMainScroll: false,
      recSelectedSort: "createdAt",
      recSelectedOrder: -1,
      total: 0,
      count: 10,
      pageStart: 1,
      currentPage: 1,
      goToPage: null,
      pageEnd: 0,

      customFieldsArray: [],
      viewCandidateModal: false,
      selectedCandidate: {},
      isExcelBoolean: false,

      //Loaders
      sourceLoader: true,
      expLoader: true,
    };
  },
  created() {
    this.LoaderStatus = true;
    this.recMainSpinner = true;
    this.getRecReports();
    this.sourceMainScroll = true;
    this.getSourced();
    this.recSelectedMainScroll = true;
    this.getSelected();
    this.getCustomField();
    this.sourceCustomerReport();
    this.assessmentTakenGraph();
    if (this.$route.query.history) {
      this.viewCandidate(this.storedData.candidate);
    }
  },
  computed: {
    ...mapGetters("jobDescriptionVUEX", {
      storedData: "getSelectedCandidate",
    }),
    DisplayTimeline() {
      if (this.timeline == "today" || this.storeTimeline == "today") {
        return "Today";
      } else if (
        this.timeline == "thisWeek" ||
        this.storeTimeline == "thisWeek"
      ) {
        return "This Week";
      } else if (
        this.timeline == "thisYear" ||
        this.storeTimeline == "thisYear"
      ) {
        return "This Year";
      } else if (this.timeline == "custom" && this.appliedFilter) {
        return "Custom";
      } else if (
        this.timeline == "thisMonth" ||
        this.storeTimeline == "thisMonth"
      ) {
        return "This Month";
      } else {
        return this.storeTimeline;
      }
    },
    checkTimeLineData() {
      return (
        this.timeline == "today" ||
        this.timeline == "thisWeek" ||
        this.timeline == "thisYear" ||
        this.timeline == "thisMonth" ||
        this.timeline == "custom"
      );
    },
    displayedSkills() {
      const skills = this.getSkills();
      return this.skillListOpen ? skills : skills.slice(0, 10);
    },
    remainingSkillCount() {
      const skills = this.getSkills();
      return skills.length - 10;
    },
    hasSkills() {
      return (
        this.getSourcedData.length > 0 &&
        this.getSourcedData[0].uniqueSkills.length > 0
      );
    },
    hasMoreThan32Skills() {
      return this.getSkills().length > 32;
    },
  },
  mounted() {
    document.addEventListener("click", this.handleClickOutside);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.handleClickOutside);
  },
  methods: {
    handlePaste(event) {
      const clipboardData = event.clipboardData;
      const pastedData = clipboardData.getData("Text");

      if (!/^\d*$/.test(pastedData)) {
        event.preventDefault();
      } else {
        this.goToPage = pastedData.replace(/\D/g, "");
      }
    },
    NumbersOnly(evt) {
      NumbersOnly(evt);
    },
    updatePage(page) {
      this.count = page;
      this.currentPage = 1;
      this.getSelected();
    },
    handlePageChange(page) {
      this.currentPage = page;
      this.getSelected();
    },
    handleGoToPage() {
      if (
        this.goToPage &&
        this.goToPage > 0 &&
        this.goToPage <= Math.ceil(this.total / this.count)
      ) {
        this.currentPage = this.goToPage;
        this.getSelected();
      } else {
        this.goToPage = null;
      }
    },
    convertDateFormat(dateStr) {
      if (dateStr) {
        const [day, month, year] = dateStr.split("-");
        return `${year}-${month}-${day}`;
      } else {
        return "";
      }
    },
    convertDate(dateStr) {
      if (dateStr) {
        const [year, month, day] = dateStr.split("-");

        return `${day}-${month}-${year}`;
      }
      return "";
    },
    handleClickOutside(event) {
      let picker = document.getElementsByClassName("mx-datepicker-main")[0];
      let dropdown = this.$refs.dropdown1;
      let timeItem = event.target.closest("li.mx-time-item");
      if (
        !picker?.contains(event.target) &&
        !dropdown?.contains(event.target) &&
        !timeItem
      ) {
        this.fromDate = this.storeFromDate;
        this.toDate = this.storeToDate;
        this.startTime = this.storeStartTime;
        this.endTime = this.storeEndTime;
        this.durationListOpen = false;
        this.customDurationOpen = false;
        if (!this.appliedFilter) {
          this.appliedFilter = false;
        }
      }
    },
    openExcel() {
      this.isExcelBoolean = true;
      this.LoaderStatus = true;
      this.getExcel();
    },
    async getExcel() {
      try {
        let payload = {
          excel: this.isExcelBoolean,
          sortBy: this.recSort,
          order: this.recOrder,
          timeline: this.timeline,
          startDate: this.convertDateFormat(this.fromDate),
          endDate: this.convertDateFormat(this.toDate),
          startTime: this.startTime,
          endTime: this.endTime,
        };
        const res = await getRecruiterReportsEcel(payload);
        if (res.status == 200) {
          this.LoaderStatus = false;
          // window.open(res.data.Detail.file);
          const href = URL.createObjectURL(res.data);

          // create "a" HTML element with href to file & click
          const link = document.createElement("a");
          link.href = href;
          link.setAttribute("download", `Recruiter Reports.xlsx`);

          document.body.appendChild(link);
          link.click();

          // clean up "a" element & remove ObjectURL
          document.body.removeChild(link);
          URL.revokeObjectURL(href);
        }
      } catch (err) {
        console.error(err);
      }
    },
    areAllCountsZero(data, property) {
      return data.every((item) => item[property] === 0);
    },
    async sourceCustomerReport() {
      if (
        document.getElementById("sourceGraph") &&
        document.getElementById("sourceGraph").innerHTML != ""
      ) {
        document.getElementById("sourceGraph").innerHTML = "";
      }
      this.sourceLoader = true;
      try {
        let payload = {
          timeline: this.timeline,
          startDate: this.convertDateFormat(this.fromDate),
          endDate: this.convertDateFormat(this.toDate),
          startTime: this.startTime,
          endTime: this.endTime,
        };
        if (this.selectedRecID) {
          payload.recruiterUserID = this.selectedRecID;
        }

        const res = await RecSourseGraph(payload);
        if (res.status == 200) {
          const fixData = res.data.data.sources;
          this.totalSourceCount = res.data.data.overallCount;
          const clrScale = [
            "#4070EA",
            "#F5D06E",
            "#038E00",
            "#AD1927",
            "#595959",
            "#269C8A",
          ];
          this.sourceGraphData = fixData.map((d, i) => {
            return {
              roleName: d.text,
              percentage: d.percentage,
              clrCode: clrScale[i],
              count: d.count,
            };
          });
          this.noSourceData = this.areAllCountsZero(
            this.sourceGraphData,
            "percentage"
          );
          const margin = { top: 50, right: 50, bottom: 40, left: 150 };
          //  const start_point = margin.right;

          setTimeout(() => {
            if (document.getElementById("sourceGraph").innerHTML != "") {
              document.getElementById("sourceGraph").innerHTML = "";
            }
            let pieChart = new rolePieChart();
            pieChart.pieGraph(
              "#sourceGraph",
              "sourceGraph",
              this.sourceGraphData,
              margin
            );
          }, 200);
        }
      } catch (error) {
        console.error(error);
      }
      this.sourceLoader = false;
    },

    async assessmentTakenGraph() {
      if (
        document.getElementById("assesmentTakenGraph") &&
        document.getElementById("assesmentTakenGraph").innerHTML != ""
      ) {
        document.getElementById("assesmentTakenGraph").innerHTML = "";
      }
      this.expLoader = true;
      try {
        let payload;
        let full_data2;
        payload = {
          timeline: this.timeline,
          startDate: this.convertDateFormat(this.fromDate),
          endDate: this.convertDateFormat(this.toDate),
          startTime: this.startTime,
          endTime: this.endTime,
        };
        if (this.selectedRecID) {
          payload.recruiterUserID = this.selectedRecID;
        }
        let passDatas;
        const resp = await RecCandExperience(payload);
        if (resp.status == 200) {
          full_data2 = resp.data.data.years;
          passDatas = full_data2.map((d) => {
            return {
              assessmentDate: d.yearField,
              count: d.candidateCount,
            };
          });
          this.noExperienceData = this.areAllCountsZero(passDatas, "count");
          this.overallCountAssessment = resp.data.data.overallCount;
          // max2 = Math.max(...full_data2.map((o) => o.count));
          // allBarData2 = resp.data.data.dates;
          // xScaleDomain2 = full_data2.map((d) => d.assessmentDate);
          // console.log("my fulll data ", full_data2)
        }
        setTimeout(() => {
          if (document.getElementById("assesmentTakenGraph").innerHTML != "") {
            document.getElementById("assesmentTakenGraph").innerHTML = "";
          }

          let assessGraph = new horizontalScroll();
          assessGraph.verticalBar2("#assesmentTakenGraph", passDatas);
        }, 200);
      } catch (error) {
        console.error(error);
      }
      this.expLoader = false;
    },

    cancelFilterSection() {
      this.overallReportsFilter = false;
    },
    viewCandidate(selectedVend) {
      this.viewCandidateModal = true;
      this.selectedCandidate = selectedVend;
    },
    closeViewIcon() {
      this.viewCandidateModal = false;
      this.selectedCandidate = {}; // Update selectedCandidate based on the event
    },
    async getCustomField() {
      try {
        let parentID = "5";
        let response = await getCustomerFields({ parentID });
        if (response.status == 200) {
          this.customFieldsArray = response.data.data.fields;
        }
      } catch (error) {
        console.error(error);
      }
    },
    formattedSkills(skills) {
      if (!Array.isArray(skills) || skills.length === 0) {
        return "";
      }
      const skillNames = skills.map((skill) => skill);
      if (skillNames.length <= 3) {
        return skillNames.join(", ");
      } else {
        return skillNames.slice(0, 3).join(", ") + "...";
      }
    },
    formattedSkillsTooltip(skills) {
      if (!Array.isArray(skills) || skills.length === 0) {
        return "";
      }
      return skills.join(", ");
    },
    getSkills() {
      const data = this.getSourcedData && this.getSourcedData[0];
      return data && Array.isArray(data.uniqueSkills) ? data.uniqueSkills : [];
    },
    searchoverALlPanel() {
      this.checkoverAllScrollLoader = true;
      this.overAllRecData = [];
      this.overAllPage = 0;
      this.showOverAllLoader = true;
      this.getOverAllRecruiters();
    },
    async getOverAllRecruiters() {
      try {
        let payload = {
          page: this.overAllPage,
          order: this.overAllOrder,
          count: this.overAllCount,
          sortBy: this.overAllSort,
          searchQuery: this.overAllSearchQuery,
          timeline: this.timeline,
          startDate: this.convertDateFormat(this.fromDate),
          endDate: this.convertDateFormat(this.toDate),
          startTime: this.startTime,
          endTime: this.endTime,
        };
        const res = await getRecruiterReports(payload);
        if (res.status == 200) {
          if (this.overAllCustPage == 0) {
            this.overAllRecData = res.data.data.data;
          } else {
            this.overAllRecData = [
              ...this.overAllRecData,
              ...res.data.data.data,
            ];
          }
          this.overAllTotal = res.data.data.total;
          this.overAllPageEnd = res.data.data.pageEnd;
          this.checkoverAllScrollLoader = false;
          this.showOverAllLoader = false;
        }
      } catch (err) {
        console.error(err);
      }
    },
    scrollOverAllPanel(e) {
      const { target } = e;
      if (
        Math.ceil(target.scrollTop) >=
        target.scrollHeight - target.offsetHeight
      ) {
        if (
          this.checkbetween(this.overAllPageEnd, 0, this.overAllTotal) &&
          !this.checkoverAllScrollLoader
        ) {
          this.checkoverAllScrollLoader = true;
          this.overAllPage++;
          this.getOverAllRecruiters();
        }
      }
    },
    SelectOverallRow(name, recID) {
      this.selectedRow = recID;
      this.selectedRowName = name;
      this.selectedRecID = recID;
      this.sourceMainScroll = true;
      this.getSourced();
      this.recSelectedPage = 0;
      this.recSelectedMainScroll = true;
      this.getSelected();
      this.overAllSearchQuery = "";
      this.overallReportsFilter = false;
      this.assessmentTakenGraph();
      this.sourceCustomerReport();
    },
    SelectRow(name, recID) {
      if (this.selectedRow === recID) {
        this.selectedRow = "all";
        this.selectedRowName = "";
        this.selectedRecID = "";
      } else {
        this.selectedRow = recID;
        this.selectedRowName = name;
        this.selectedRecID = recID;
      }
      this.sourceMainScroll = true;
      this.getSourced();
      this.recSelectedPage = 0;
      this.recSelectedMainScroll = true;
      this.getSelected();
      this.overAllSearchQuery = "";
      this.overallReportsFilter = false;
      this.assessmentTakenGraph();
      this.sourceCustomerReport();
    },
    selectAllpanelRow() {
      this.selectedRow = "all";
      this.selectedRecID = "";
      this.sourceMainScroll = true;
      this.getSourced();
      this.recSelectedPage = 0;
      this.recSelectedMainScroll = true;
      this.getSelected();
      this.overAllSearchQuery = "";
      this.overallReportsFilter = false;
      this.assessmentTakenGraph();
      this.sourceCustomerReport();
    },
    getSearchSelectedData() {
      this.recSelectedPage = 0;
      this.recSelectedMainScroll = true;
      this.getSelected();
    },
    sortSelectedData(sort, order) {
      this.recSelectedSort = sort;
      this.recSelectedOrder = order;
      this.getSearchSelectedData();
    },
    async getSelected() {
      try {
        let payload = {
          count: this.count,
          page: this.currentPage - 1,
          searchQuery: this.recSelectedSearchQuery,
          sortBy: this.recSelectedSort,
          order: this.recSelectedOrder,
          timeline: this.timeline,
          startDate: this.convertDateFormat(this.fromDate),
          endDate: this.convertDateFormat(this.toDate),
          startTime: this.startTime,
          endTime: this.endTime,
        };
        if (this.selectedRecID !== "") {
          payload.recruiterUserID = this.selectedRecID;
        }
        const res = await getSelectedRecruiter(payload);
        if (res.status == 200) {
          this.recSelectedData = res.data.data.data;
          this.total = res.data.data.total;
          this.pageEnd = res.data.data.pageEnd;
          this.recSelectedMainScroll = false;
        }
      } catch (err) {
        console.error(err);
      }
    },
    async getSourced() {
      try {
        let payload = {
          timeline: this.timeline,
          startDate: this.convertDateFormat(this.fromDate),
          endDate: this.convertDateFormat(this.toDate),
          startTime: this.startTime,
          endTime: this.endTime,
        };
        if (this.selectedRecID !== "") {
          payload.recruiterUserID = this.selectedRecID;
        }
        const res = await getRecruiterSources(payload);
        if (res.status == 200) {
          this.sourceMainScroll = false;
          this.getSourcedData = res.data.data;
        }
      } catch (err) {
        console.error(err);
      }
    },
    cancelCustom() {
      this.fromDate = this.storeFromDate;
      this.toDate = this.storeToDate;
      this.startTime = this.storeStartTime;
      this.endTime = this.storeEndTime;
      this.durationListOpen = false;
      this.customDurationOpen = false;
      if (!this.appliedFilter) {
        this.appliedFilter = false;
      }
    },
    resetCustom() {
      this.storeFromDate = "";
      this.storeToDate = "";
      this.storeStartTime = "";
      this.storeEndTime = "";
      this.fromDate = "";
      this.toDate = "";
      this.startTime = "";
      this.endTime = "";
      this.appliedFilter = false;
      this.timeline = "thisMonth";
      this.storeTimeline = "thisMonth";
      this.recMainSpinner = true;
      this.getRecReports();
      this.sourceMainScroll = true;
      this.getSourced();
      this.recSelectedMainScroll = true;
      this.getSelected();
      this.showOverAllLoader = true;
      this.getOverAllRecruiters();
      this.durationListOpen = false;
      this.customDurationOpen = false;
    },
    applyCustom() {
      this.appliedFilter = true;
      this.storeFromDate = this.fromDate;
      this.storeToDate = this.toDate;
      this.storeStartTime = this.startTime;
      this.storeEndTime = this.endTime;
      this.recMainSpinner = true;
      this.getRecReports();
      this.sourceMainScroll = true;
      this.getSourced();
      this.recSelectedMainScroll = true;
      this.getSelected();
      this.durationListOpen = false;
      this.customDurationOpen = false;
      this.sourceCustomerReport();
      this.assessmentTakenGraph();
      this.storeTimeline = "custom";
      this.timeline = "custom";
    },
    setTimeline(value) {
      this.timeline = value;
      if (this.selectedRow !== "all") {
        this.selectedRow = "all";
        this.selectedRecID = "";
      }
      if (value !== "custom") {
        this.recMainSpinner = true;
        this.recPage = 0;
        this.getRecReports();
        this.sourceMainScroll = true;
        this.getSourced();
        this.recSelectedMainScroll = true;
        this.getSelected();
        this.durationListOpen = false;
        this.customDurationOpen = false;
        this.sourceCustomerReport();
        this.assessmentTakenGraph();
        this.storeTimeline = this.timeline;
        this.storeFromDate = "";
        this.storeToDate = "";
        this.storeStartTime = "";
        this.storeEndTime = "";
      }
    },
    async getRecReports() {
      try {
        let payload = {
          page: this.recPage,
          count: this.recCount,
          searchQuery: this.recSearchQuery,
          sortBy: this.recSort,
          order: this.recOrder,
          timeline: this.timeline,
          startDate: this.convertDateFormat(this.fromDate),
          endDate: this.convertDateFormat(this.toDate),
          startTime: this.startTime,
          endTime: this.endTime,
        };
        const res = await getRecruiterReports(payload);
        if (res.status == 200) {
          this.LoaderStatus = false;
          if (this.recPage == 0) {
            this.recData = res.data.data.data;
          } else {
            this.recData = [...this.recData, ...res.data.data.data];
          }
          this.recTotal = res.data.data.total;
          this.recPageEnd = res.data.data.pageEnd;
          this.recTotalCandSourced = res.data.data.totalCandidateSourced;
          this.recJobsAssigned = res.data.data.totalJobsAssigned;
          this.recSchedCount = res.data.data.interviewScheduledCount;
          this.recTotalSelect = res.data.data.totalSelected;
          this.recMainSpinner = false;
          this.recScrollSpinner = false;
        }
      } catch (err) {
        console.error(err);
      }
    },
    getSearchedRec() {
      this.recScrollSpinner = true;
      this.recPage = 0;
      this.recMainSpinner = true;
      this.getRecReports();
    },
    sortData(sort, order) {
      this.recSort = sort;
      this.recOrder = order;
      this.getSearchedRec();
    },
    recScroll(e) {
      const { target } = e;
      if (
        Math.ceil(target.scrollTop) >=
        target.scrollHeight - target.offsetHeight
      ) {
        if (
          this.checkbetween(this.recPageEnd, 0, this.recTotal) &&
          !this.recScrollSpinner
        ) {
          this.recScrollSpinner = true;
          this.recPage++;
          this.getRecReports();
        }
      }
    },
    checkbetween(x, min, max) {
      return x > min && x < max;
    },
    goBack() {
      if (this.$route.query.status == "dashboard") {
        this.$router.push({
          name: "MainDashboard",
        });
      } else {
        this.$router.push({
          name: "ReportDashboard",
        });
      }
    },
    showAllSourcedSkills() {
      this.skillListOpen = !this.skillListOpen;
    },
    openDurationList() {
      this.durationListOpen = !this.durationListOpen;
      this.customDurationOpen = false;
      this.overallReportsFilter = false;
    },
    closeDurationList() {
      this.durationListOpen = false;
    },
    openCustomDuration() {
      this.customDurationOpen = true;
    },
    closeCustomDuration() {
      this.customDurationOpen = false;
    },
    toggleReportsFilter() {
      this.overallReportsFilter = !this.overallReportsFilter;
      this.overAllPage = 0;
      this.overAllRecData = [];
      this.showOverAllLoader = true;
      this.getOverAllRecruiters();
    },
  },
};
</script>
<style scoped>
.new-reports {
  position: relative;
  padding: 15px 20px 0px 77px;
  top: 71px;
  height: calc(100vh - 71px);
  background-color: #e9ecef;
  overflow-y: scroll;
  font-family: "Lato", sans-serif;
}

.new-reports .new-reports-header {
  background-color: #f6f9fb;
  border-radius: 6px;
}

.new-reports .new-reports-header .title-nav {
  gap: 18px;
}

.new-reports .new-reports-header .title-nav .title {
  color: #20639b;
  font-weight: 600;
  font-size: 20px;
}

.new-reports .new-reports-header .daily-option {
  position: relative;
}

.new-reports .new-reports-header .daily-option .report-duration-dropdown {
  position: absolute;
  top: 100%;
  display: flex;
  flex-direction: column;
  width: 100%;
  background-color: #fff;
  box-shadow: 0 0 15px #82828290;
  z-index: 300;
}

.new-reports
  .new-reports-header
  .daily-option
  .report-duration-dropdown
  .duration-item {
  transition: all 0.2s ease;
  font-size: 13px;
  font-weight: 500;
  padding: 8px 10px;
}

.new-reports
  .new-reports-header
  .daily-option
  .report-duration-dropdown
  .duration-item:hover {
  background-color: #e8eff4;
}

.new-reports
  .new-reports-header
  .daily-option
  .report-duration-dropdown
  .duration-item.custom {
  position: relative;
}

.custom-duration-menu {
  position: absolute;
  background: #ffffff;
  right: 95%;
  top: 10%;
  box-shadow: 0 0 15px #82828290;
  border-radius: 6px;
  width: 280px;
}

.custom-duration-menu .custom-title {
  font-weight: 600;
  font-size: 16px;
}

.custom-duration-menu form {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.custom-duration-menu form .custom-button-field {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
}

.custom-duration-menu form .custom-button-field button {
  padding: 4px 14px;
  border-radius: 20px;
  font-weight: 600;
  font-size: 13px;
}

.custom-duration-menu form .custom-button-field button.cancel {
  color: #20639b;
  background-color: white;
  border: 2px solid #20639b;
}

.custom-duration-menu form .custom-button-field button.apply {
  color: white;
  background-color: #20639b;
  border: 2px solid #20639b;
}

.custom-duration-menu form .custom-input-field {
  display: flex;
  flex-direction: column;
}

.custom-duration-menu form .custom-input-field label {
  font-size: 14px;
}

.custom-duration-menu form .custom-input-field .date-picker-field {
  display: flex;
  align-items: center;
  padding: 6px 10px;
  border-radius: 10px;
  justify-content: space-between;
  width: 100%;
  border: 1px solid #a8a8a8;
}

.custom-duration-menu form .custom-input-field .date-picker-field span {
  color: #667085;
}

.new-reports .new-reports-header .daily-option > button {
  gap: 18px;
  outline: none;
  border: none;
  background-color: #20639b;
  color: white;
  border-radius: 20px;
}

.new-reports .overview-tab {
  background: #fff;
  margin-top: 10px;
  border-radius: 6px;
  display: flex;
  align-items: center;
}

.new-reports .overview-tab .tab-title {
  font-weight: 600;
}

.new-reports .overview-tab .overview-items-flex {
  margin-left: 5%;
  justify-content: space-around;
  flex-wrap: wrap;
}

.new-reports .overview-tab .overview-items-flex .overview-item {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 12px;
  font-weight: 500;
}

.new-reports .overview-tab .overview-items-flex .overview-item .item-value {
  color: #20639b;
}

.new-reports .table-panel {
  background-color: #fff;
  border-radius: 6px;
  margin-top: 10px;
}

.new-reports .table-panel .table-title-bar {
  border-bottom: 1px solid #dddddd;
}

.new-reports .table-panel .table-title-bar .table-title {
  font-weight: 600;
}

.new-reports .table-panel .table-title-bar .search-export-options {
  gap: 18px;
}

.new-reports .table-panel .table-title-bar .search-bar {
  /* gap: 12px; */
  background-color: #f4f4f6;
  width: max-content;
  border-radius: 20px;
}

.new-reports .table-panel .table-title-bar .search-bar input {
  background-color: transparent;
  border: none;
  height: 30px;
}

.new-reports .table-panel .table-title-bar .export-excel {
  outline: none;
  border: none;
  background-color: #20639b;
  color: white;
  border-radius: 20px;
}

.new-reports .table-panel .table-container {
  position: relative;
}

.new-reports .table-panel .table-container .table-header {
  background-color: #e9f0f5;
  gap: 10px;
  display: flex;
  align-items: center;
}

.new-reports .table-panel .table-container .table-header .header-item {
  font-size: 14px;
  font-weight: 600;
  color: #20639b;
  gap: 4px;
}

.new-reports
  .table-panel
  .table-container
  .table-header
  .header-item
  .sort-header {
  gap: 2px;
}

.new-reports
  .table-panel
  .table-container
  .table-header
  .header-item
  .sort-header
  img {
  cursor: pointer;
}

.new-reports .table-panel .table-container .table-header > * {
  flex: 1;
}

.new-reports .table-panel .table-container .table-data-rows {
  margin-top: 10px;
  max-height: 365px;
  overflow-y: scroll;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.new-reports .table-panel .table-container .table-data-rows .data-row {
  background-color: #fff;
  display: flex;
  align-items: center;
  gap: 10px;
  border-left: 3px solid #20639b;
  box-shadow: 0 0 15px #dedede;
}

.new-reports .table-panel .table-container .table-data-rows .data-row:hover {
  background-color: #e3e3fe;
}

.new-reports .table-panel .table-container .table-data-rows .data-row > * {
  flex: 1;
  font-size: 15px;
  font-weight: 400;
  color: #20639b;
}

.new-reports .sourced-skills {
  margin-top: 10px;
  border-radius: 6px;
  background-color: #fff;
}

.new-reports .sourced-skills .source-title-bar {
  border-bottom: 1px solid #dddddd;
}

.new-reports .sourced-skills .source-title {
  font-weight: 600;
}

.new-reports .sourced-skills .skills-chips-flex {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.new-reports .sourced-skills .skills-chips-flex .chip {
  background-color: #eff6fb;
  color: #85a9c8;
  font-size: 14px;
  font-weight: 500;
}

.new-reports .sourced-skills .skills-chips-flex .chip.show-all {
  background-color: #85a9c8;
  color: #eff6fb;
  text-decoration: underline;
  text-underline-offset: 2px;
  cursor: pointer;
}

/* Overall Reports Section */

.new-reports .overall-reports {
  margin-top: 10px;
}

.new-reports .overall-reports .overall-reports-header .title-section .title {
  font-weight: 600;
}

.new-reports
  .overall-reports
  .overall-reports-header
  .title-section
  .sub-title {
  color: #888888;
  font-style: italic;
}

.new-reports .overall-reports .overall-reports-header .filter-section {
  gap: 10px;
}

.new-reports
  .overall-reports
  .overall-reports-header
  .filter-section
  .custom-dropdown {
  position: relative;
  font-size: 14px;
}

.new-reports
  .overall-reports
  .overall-reports-header
  .filter-section
  .custom-dropdown
  .selected-filter {
  background-color: transparent;
  gap: 12px;
  color: #20639b;
  cursor: pointer;
}

.new-reports
  .overall-reports
  .overall-reports-header
  .filter-section
  .custom-dropdown
  .filter-list-dropdown {
  position: absolute;
  right: 0;
  top: 30px;
  background-color: #fff;
  z-index: 300;
  border-radius: 6px;
  box-shadow: 0 0 15px #10101047;
}

.new-reports
  .overall-reports
  .overall-reports-header
  .filter-section
  .custom-dropdown
  .filter-list-dropdown
  .filter-search {
  background-color: #f1f1f1;
  display: flex;
  align-items: center;
  padding: 2px 10px;
  gap: 10px;
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
}

.new-reports
  .overall-reports
  .overall-reports-header
  .filter-section
  .custom-dropdown
  .filter-list-dropdown
  .filter-search
  input {
  background-color: #f1f1f1;
  border: none;
}

.new-reports
  .overall-reports
  .overall-reports-header
  .filter-section
  .custom-dropdown
  .filter-list-dropdown
  .filter-list {
  display: flex;
  flex-direction: column;
  min-height: auto;
  max-height: 165px;
  overflow-y: scroll;
}

.new-reports
  .overall-reports
  .overall-reports-header
  .filter-section
  .custom-dropdown
  .filter-list-dropdown
  .filter-list
  > * {
  padding: 10px;
  cursor: pointer;
}

.new-reports .overall-reports .overall-reports-flex {
  display: flex;
  align-items: center;
  gap: 12px;
}

.new-reports .overall-reports .overall-reports-flex > * {
  flex: 1;
}

.new-reports .overall-reports .overall-reports-flex .overall-reports-item {
  background-color: #fff;
  border-radius: 6px;
}

.new-reports
  .overall-reports
  .overall-reports-flex
  .overall-reports-item
  .report-title {
  border-bottom: 1px solid #dddddd;
}

.new-reports
  .overall-reports
  .overall-reports-flex
  .overall-reports-item
  .report-content {
  position: relative;
  min-height: 250px;
}

.new-reports
  .overall-reports
  .overall-reports-flex
  .overall-reports-item
  .report-content
  .sample-legend {
  border-radius: 10px;
  border: 1px solid black;
  padding: 10px;
  width: max-content;
  position: absolute;
  bottom: 25px;
  right: 25px;
}

.new-reports
  .overall-reports
  .overall-reports-flex
  .overall-reports-item
  .report-content
  .sample-legend
  .legend-item {
  gap: 10px;
  font-size: 11px;
}

.new-reports
  .overall-reports
  .overall-reports-flex
  .overall-reports-item
  .report-content
  .sample-legend
  .legend-item
  .color-disc {
  height: 6px;
  aspect-ratio: 1/1;
  border-radius: 100%;
  background-color: green;
}

.sample-legend-selection {
  border-radius: 10px;
  border: 1px solid black;
  padding: 10px;
  width: max-content;
  position: absolute;
  top: 15px;
  right: 25px;
}

.color-disc {
  height: 6px;
  aspect-ratio: 1/1;
  border-radius: 100%;
}

/* Overall Reports Section End*/

@media screen and (max-width: 1024px) {
  .new-reports {
    padding: 15px 20px 0px 20px;
  }
}

.legend-container {
  border: 1px solid #333333;
  border-radius: 12px;
  width: fit-content;
  position: absolute;
  padding: 6px 10px;
  right: 25px;
  bottom: 21px;
}

.legend-color-disc {
  height: 7px;
  width: 7px;
  border-radius: 50%;
  margin-right: 5px;
}

.legend-item-name {
  font-family: "Montserrat", sans-serif;
  font-size: 11px;
  font-weight: 500;
  line-height: 13.41px;
  text-align: left;
  color: #333333;
}
.selec-rate-font {
  font-family: "Montserrat", sans-serif;
  font-weight: 400;
  font-size: 9px;
  color: #72738e;
}
</style>
